import track from 'analytics/track';

/**
 * Calls the Expand Deep Dive Answer event when a user opens a Deep Dive on a PDP.
 * @param {string} productCategory The product category of the PDP's respective product
 * @param {string} question The english translation of the question in the deep dive prompt
*/
export const deepDiveExpand = (productCategory, question) => {
  const trackParams = {
    params: {
      ga: {
        eventAction: `Expand Deep Dive Answer`,
        eventCategory: productCategory,
        eventLabel: question,
      },
      heap: {
        eventName: `Expand Deep Dive Answer`,
        properties: {
          question,
          category: productCategory,
        },
      },
    },
  };
  track(trackParams);
};
